import React from 'react'
import './css/Header.css'
import Headerbg from './Headerbg'
import Navbar from './Navbar/Navbar'

const Header = () => (
    <header id="page-topbar">
        <Headerbg />
        <Navbar />
    </header>
)

export default Header
